import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
} from '@mui/material';
import { FC, useState } from 'react';

import { useDeleteApplicationNote } from '@features/applicationNotes/hooks/useDeleteApplicationNote';
import { useDeleteEnterpriseApplicationNote } from '@features/applicationNotes/hooks/useDeleteEnterpriseApplicationNote';

type DeleteEnterpriseNoteModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  applicationId: number;
  company_id: number;
  applicationNoteId: number | null;
  clearSelectedNote: () => void;
};

const DeleteEnterpriseNoteModal: FC<DeleteEnterpriseNoteModalProps> = ({
  isOpen,
  handleClose,
  applicationId,
  company_id,
  applicationNoteId,
  clearSelectedNote,
}) => {
  const [errorText, setErrorText] = useState('');

  const { deleteNote, isDeleteNoteLoading } = useDeleteEnterpriseApplicationNote({
    applicationId,
    setErrorText,
  });

  const handleDelete = () =>
    deleteNote(
      { application_note_id: applicationNoteId as number, company_id: company_id },
      {
        onSuccess: () => {
          clearSelectedNote();
          handleClose();
        },
      },
    );

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Delete this note?</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          {errorText && <Alert severity="error">{errorText}</Alert>}
          <LoadingButton
            variant="outlined"
            color="error"
            onClick={handleDelete}
            loading={isDeleteNoteLoading}
          >
            Delete
          </LoadingButton>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteEnterpriseNoteModal;
